import { Component, OnInit } from '@angular/core';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'md-booking-warning-banner',
    template: `<div *ngIf="isBooking" class="booking-banner">
        This is a test environment.
        <ng-container *ngIf="isBookingAndPointingToProd"
            >CAREFUL! This website will make changes in
            production.</ng-container
        >
    </div>`,
    styles: [
        `
            .booking-banner {
                position: fixed;
                height: 20px;
                width: 100%;
                top: 0;
                left: 0;
                background-color: red;
                z-index: 1000;
                color: white;
                text-align: center;
                font-size: 14px;
                overflow: hidden;
            }
        `,
    ],
})
export class BookingWarningBannerComponent implements OnInit {
    ngOnInit(): void {
        this.isBooking = this.isBookingUrl();
        this.isBookingAndPointingToProd =
            this.isBooking && this.isPointingToProd();
    }
    isBooking = false; // This is set to true if the website is currently shown through booking.marideal.mu
    isBookingAndPointingToProd = false;

    private isBookingUrl() {
        return window.location.href.includes('booking.marideal.mu');
    }

    private isPointingToProd() {
        return environment.apiUrl.includes('apimdb.marideal.mu');
    }
}
